import React from 'react';
import { Button, Icon } from 'components/ui';

interface StepNavigationProps {
  currentStep: number;
  totalSteps: number;
  onNext: () => void;
  onPrev: () => void;
  isSubmitting?: boolean;
  canGoNext?: boolean;
  editingFromSummary?: boolean;
}

const StepNavigation: React.FC<StepNavigationProps> = ({
  currentStep,
  totalSteps,
  onNext,
  onPrev,
  isSubmitting = false,
  canGoNext = true,
  editingFromSummary = false,
}) => {
  const isFirstStep = currentStep === 1;
  const isLastStep = currentStep === totalSteps;

  return (
    <div
      className={`flex ${
        isFirstStep || editingFromSummary ? 'justify-center' : 'justify-between'
      } items-center mt-8 pt-6 border-t-0 border-text ${isLastStep && 'hidden'}`}
    >
      {/* Back button - only show on steps 2-7, but hide when editing from summary */}
      {!isFirstStep && !editingFromSummary && (
        <Button type="button" variant="outline" size="sm" className="w-1/5" onClick={onPrev}>
          <Icon type="backArrow" className="w-3 mr-2" />
          Back
        </Button>
      )}

      {/* Continue button - show on steps 1-7 */}
      {!isLastStep && (
        <Button
          type="button"
          variant="primary"
          size="sm"
          className={
            isFirstStep || editingFromSummary ? 'w-5/6 mx-auto relative' : 'w-1/2 relative'
          }
          onClick={onNext}
          disabled={!canGoNext}
        >
          {editingFromSummary ? 'Save & Return to Summary' : 'Continue'}{' '}
          <Icon type="rightArrow" className="w-4 absolute right-5 fill-slate-100" />
        </Button>
      )}
    </div>
  );
};

export { StepNavigation };
